var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('TableApp', {
    ref: "usuarios",
    attrs: {
      "titulo": "Usuários",
      "acaoBtn": "/#/usuarios/novo",
      "textoBtn": "Novo",
      "api-url": "/usuario",
      "fields": _vm.fields,
      "classFilterColumn": "descricao",
      "perPage": 10
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'nome' ? _c('span', {
          attrs: {
            "slot": "nome"
          },
          slot: "nome"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', [_c('a', {
          staticClass: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg",
          attrs: {
            "href": "#"
          }
        }, [_vm._v(_vm._s(props.rowData.nome))]), _c('span', {
          staticClass: "text-muted font-weight-bold d-block"
        }, [_vm._v(" " + _vm._s(props.rowData.usuario) + " ")]), props.rowData.entregador_habilitado ? _c('span', {
          staticClass: "label label-inline label-light-primary mt-1"
        }, [_vm._v(" Entregador ")]) : _vm._e()])])])]) : _vm._e(), props.field == 'status' ? _c('span', [props.rowData.status == 'A' ? _c('span', {
          staticClass: "label label-lg label-inline label-light-success"
        }, [_vm._v("Ativo")]) : _c('span', {
          staticClass: "label label-lg label-inline label-light-danger"
        }, [_vm._v("Inativo")])]) : _vm._e(), props.field == 'actions' && _vm.currentUser.admin && _vm.currentUser.id_usuario !== props.rowData.id_usuario ? _c('span', [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "dropdown dropdown-inline"
        }, [_c('router-link', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Editar',
            expression: "'Editar'"
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          attrs: {
            "to": {
              name: 'usuariosEditar',
              params: {
                id: props.rowData.id_usuario
              }
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16,
            "title": "Editar"
          }
        })], 1), !props.rowData.admin ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Excluir',
            expression: "'Excluir'"
          }],
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.excluir(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1) : _vm._e()], 1)])])]) : _vm._e()];
      }
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };